import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs';

import { ApiService } from '@app/services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class PortalTierCatalogService {
  catalog$ = this.apiService.portalTierCatalog().pipe(shareReplay(1));

  constructor(private apiService: ApiService) {}
}
